import $rules from '@/assets/javascript/rules'

export  default {
    fullName: $rules.required,
    idCardNo: $rules.required,
    corporation: $rules.required,
    corporationIdCardNo: [{ required: true, message: "请输入身份证号码", trigger: "blur" },{message:'请输入正确的身份证号码',min:18,max:18}],
    mobile: $rules.phone,
    managerName: $rules.required,
    managerPassport: $rules.required,
    managerMobile: $rules.phone,
}